import {useEffect} from "react";
import {App, Modal, message, notification} from "antd";

export function AntdStaticAdapter() {
	const {modal, message: msg, notification: noto} = App.useApp();

	useEffect(() => {
		Object.assign(Modal, modal);
		Object.assign(message, msg);
		Object.assign(notification, noto);
	}, [modal, msg, noto]);

	return null;
}
